import React from "react";
import { _ReportCampaigns } from "../../components/reports/admin/campaigns";
const ReportCampaigns = () => {
  return (
    <div>
      <h2>Campañas CLEVERTAP</h2>
      <_ReportCampaigns />
    </div>
  );
};

export default ReportCampaigns;
